import { get } from 'svelte/store';

export const getMoodEmoji = (moodLevel) => {
    if (moodLevel >= 2){
        return "01"
    }
    if (moodLevel === 1){
        return "02"
    }
    if (moodLevel === 0){
        return "03"
    }
    if (moodLevel === -1){
        return "04"
    }
    return "05"
}

export const setNewStatValue = (difference, store) => {
    let newValue = get(store) + difference;
    store.set(newValue);
}

export const parseText = (text) => {
    return text.split('<br>');
}

export const getLogicGotoStep = (logicGoto,$history) => {
    let findGoto = null;
    for (const key in logicGoto){
        const splitted = key.split('_');
        const historyKey = splitted[0];
        const historyValue = splitted[1]-1;
        if ($history[historyKey] === historyValue){
            findGoto = logicGoto[key];
            break;
        }
    }
    return findGoto
}